import { html } from 'lit';
import { textToUnsafeHTML } from '@common/lit/textToUnsafeHTML.js';
import type { Purpose } from '@common/types/model.d.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';

//
// renders a <a> with a connected modal
//
export const tefPurposeDescriptionModal = function render(this: TefComs4p, purpose: Purpose) {
  return html`
      <tef-modal-trigger modal-id="purpose-desc-${purpose.purposeId}">
        <a href="#purpose-desc-${purpose.purposeId}" style="white-space: nowrap">Weitere Informationen</a>
      </tef-modal-trigger>
      <tef-modal id="purpose-desc-${purpose.purposeId}" close-icon color-close-icon>
        <div slot="title">${purpose.title}</div>
        <div slot="body">
          ${textToUnsafeHTML(purpose.description)}
        </div>
      </tef-modal>
    `;
};
